import { graphql, useStaticQuery } from "gatsby"

export const useTeams = () => {
  return useStaticQuery(
    graphql`
      query AllTeam {
        teams: allContentfulTeam(
          sort: { order: ASC }
          filter: { slug: { ne: "others" } }
        ) {
          nodes {
            id
            slug
            title
          }
        }
      }
    `
  )
}
